export default __webpack_public_path__ + "static/radeej-4501551e2d83fb7225b03e52bd1eff74.png";